import { cn } from "../utils/tailwind";

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-grey-100", className)}
      {...props}
    />
  );
}

export { Skeleton };
